<template>
  <div class="step-by-step-footer">
    <div
      class="step-by-step-footer__previous-panel"
    >
      <b-button
        variant="secondary"
        class="step-by-step-footer__previous-button"
        v-if="(step > 0 && saveTemplate) || step > 0"
        :disabled="!hasEnabledPreviousStep"
        @click="goToPreviousStep()"
      >
        {{ previousButtonLabel }}
      </b-button>
      <slot name="previousPanel" />
    </div>
    <div class="step-by-step-footer__next-panel">
      <slot name="nextPanel" />
      <div class="step-by-step-footer__buttons-wrapper">
        <b-button
          variant="outline-primary"
          class="save-template-simulation mr-3"
          v-if="step > 0 && saveTemplateButton"
          :disabled="nextOrConcludeButtonDisabled"
          @click="openModalSaveTemplate"
        >
          <i
            aria-hidden="true"
            class="far fa-save mr-2"
          />
          {{ $t('reports.save-template') }}
        </b-button>

        <b-dropdown
          v-if="dropdownButton && isLastStep"
          class="report__dropdown-button"
          split
          variant="primary"
          boundary="window"
          :disabled="nextOrConcludeButtonDisabled"
          :text="$t('reports.filters.view-report')"
          @click="goToNextOrConclude($event)"
        >
          <b-dropdown-item @click="exportXlsx($event)" style="padding:0px">
            <b-btn
              class="btn-dropdown-export"
              variant="outline-primary"
              :disabled="nextOrConcludeButtonDisabled"
            >
              <s-loader
                v-if="exportXlsxLoading"
                class="report__xlsx-loading"
              />
              <i
                v-else
                class="fas fa-file-excel mr-1"
                aria-hidden="true"
              />
              <span>{{ $t('general.export-xlsx') }}</span>
            </b-btn>
          </b-dropdown-item>
        </b-dropdown>

        <s-loading-button
          v-else
          class="step-by-step-footer__next-button"
          variant="primary"
          :class="{ 'step-by-step-footer__conclude-button' : isLastStep }"
          :disabled="nextOrConcludeButtonDisabled"
          :loading="loading"
          @click="goToNextOrConclude($event)"
        >
          {{ nextOrConcludeButtonLabel }}
        </s-loading-button>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationMixin from '../mixins/navigationMixin';

export default {
  name: 'StepByStepFooter',

  mixins: [NavigationMixin],
  props: {
    previousButtonText: {
      required: false,
      type: String,
    },
    nextButtonText: {
      required: false,
      type: String,
    },
    saveTemplateButton: {
      type: Boolean,
      default: false,
    },
    concludeButtonText: {
      required: false,
      type: String,
    },
    concludeDisabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    saveTemplate: {
      type: Boolean,
      default: false,
    },
    dropdownButton: {
      type: Boolean,
      default: false,
    },
    saveTemplateLoading: {
      type: Boolean,
      default: false,
    },
    exportXlsxLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentRoute() {
      return this.$route.path;
    },
    previousEnabledStep() {
      for (let step = this.step - 1; step >= 0; step -= 1) {
        if (this.isStepEnabled(step)) {
          return step;
        }
      }

      return null;
    },
    hasEnabledPreviousStep() {
      if (this.saveTemplate) return true;
      return this.previousEnabledStep != null;
    },
    nextEnabledStep() {
      for (let step = this.step + 1; step < this.steps.length; step += 1) {
        if (this.isStepEnabled(step)) {
          return step;
        }
      }

      return null;
    },
    previousButtonLabel() {
      return this.previousButtonText || this.$t('general.back');
    },
    isLastStep() {
      return this.step === (this.steps.length - 1);
    },
    nextOrConcludeButtonLabel() {
      if (this.isLastStep) {
        return this.concludeButtonText || this.$t('general.conclude');
      }
      return this.nextButtonText || this.$t('general.next');
    },
    nextOrConcludeButtonDisabled() {
      if (this.isLastStep) {
        return this.concludeDisabled;
      }
      return !this.nextEnabledStep;
    },
  },
  methods: {
    goToPreviousStep(event) {
      if (this.step === 0) {
        this.$emit('backToList', event);
      } else if (this.hasEnabledPreviousStep) {
        this.goToStep(this.previousEnabledStep);
      }
    },
    goToNextStep() {
      if (this.nextEnabledStep) {
        this.goToStep(this.nextEnabledStep);
      }
    },
    conclude(event) {
      this.$emit('conclude', event);
    },
    goToNextOrConclude(event) {
      if (this.isLastStep) {
        this.conclude(event);
        return;
      }
      this.goToNextStep();
    },
    openModalSaveTemplate(event) {
      this.$emit('saveTemplate', event);
    },
    exportXlsx(event) {
      this.$emit('exportXlsx', event);
    },
  },
};
</script>
<style lang="sass" scoped>
@import src/styles/defaults/variables
@import "src/styles/defaults/mobile-first"

.step-by-step-footer
  padding: 20px
  display: flex
  flex-direction: column
  ::v-deep &__previous-panel,
  ::v-deep &__next-panel
    display: flex
    flex-direction: row
    justify-content: space-between

    button
      width: 100%
  &__next-panel
    margin-top: 5px
  +media-min-sm()
    flex-direction: row
    justify-content: space-between
    ::v-deep &__previous-panel,
    ::v-deep &__next-panel
      button
        width: auto
    &__next-panel
      margin-top: 0

  &__buttons-wrapper
    display: flex
    justify-content: flex-end
    margin-bottom: 15px

    .position-static
      position: relative !important

    ::v-deep
      .dropdown-menu.show
        padding: 0 !important
        width: 100% !important

      .dropdown-item
        padding: 0
        width: 100%

        .btn-dropdown-export
          padding: 0
          width: 100%

        & > button
          margin-top: 0 !important
          margin-bottom: 0 !important
</style>
